import React from "react";
import { ContentSection } from "sprint-common-web";

import { RecordType } from "../../../../../common/types/RecordType";
import { CloudFilePreview } from "./cloud-file-preview/CloudFilePreview";
import { CloudFileFilePreviewErrorBoundary } from "./cloud-file-preview/CloudFilePreviewErrorBoundary";
import { useCloudFilePreviewContext } from "./cloud-file-preview/hooks/useCloudFilePreviewContext";
import { VideoRekognitionResultProvider } from "./cloud-file-preview/rekognition/context/VideoRekognitionResultProvider";
import { VideoPreviewProvider } from "./cloud-file-preview/video/context/VideoPreviewProvider";
import { VideoFilePreviewSection } from "./cloud-file-preview/video/VideoFilePreviewSection";

interface CloudFilePreviewSectionProps {
    minHeight: number;
}

export const CloudFilePreviewSection = (props: CloudFilePreviewSectionProps): JSX.Element | null => {
    const { cloudFileDetails } = useCloudFilePreviewContext();

    if (cloudFileDetails.recordType === RecordType.Video) {
        return (
            <VideoRekognitionResultProvider cloudFileId={cloudFileDetails.cloudFileId}>
                <VideoPreviewProvider>
                    <VideoFilePreviewSection minHeight={props.minHeight} />
                </VideoPreviewProvider>
            </VideoRekognitionResultProvider>
        );
    }

    return (
        <ContentSection header="Preview" style={{ minHeight: props.minHeight }} testId="cloud-file-preview-section">
            <CloudFileFilePreviewErrorBoundary>
                <CloudFilePreview />
            </CloudFileFilePreviewErrorBoundary>
        </ContentSection>
    );
};
